import bind from 'bind-decorator';
import * as React from 'react';
import { APIFieldErrors } from '../../api/api';
import { InputError } from './input-error';

interface FieldProps {
  readonly label: string;
  readonly value: string;
  readonly errors?: APIFieldErrors | undefined;

  onChange(value: string): void;
}

export class Field extends React.Component<FieldProps> {
  @bind
  private onChange(e: React.ChangeEvent<HTMLInputElement>) {
    this.props.onChange(e.target.value);
  }

  public render() {
    return (
      <div>
        <label>
          <p className="small-text">{this.props.label}</p>
          <input placeholder={this.props.label} value={this.props.value} onChange={this.onChange}/>
        </label>
        <InputError errors={this.props.errors}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/field.tsx